import { CONFIGURATION_SOURCES_PATH } from 'installations/navigation';

module.exports = {
  path: CONFIGURATION_SOURCES_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationSources'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/sources/index.js